import VueRouter from "vue-router";

const Landing = {
    template: `<router-view></router-view>`
}
const routesChildrens = [];

window.routesChildrens.forEach((item) => {
    routesChildrens.push({
        name       : item.name,
        path       : item.path,
        component  : () => import(/* webpackChunkName: `${item.name}` */ '../components/' + item.route + '/' + item.component),
        props      : item.props,
        beforeEnter: (to, from, next) => {
            if (item.langFileLink) {
                let langFileScript = document.createElement('script');
                langFileScript.setAttribute('src', item.langFileLink);
                document.head.appendChild(langFileScript);
            }

            next();
        }
    });
});

export default new VueRouter({
    mode  : 'history',
    routes: [
        {
            path     : '/converters/:type',
            name     : 'home',
            component: Landing,
            children : routesChildrens
        }]
});
